import { Ass_03, Exp_01 } from "../../Chart.js";
import { NewEntry } from "../../entry/NewEntry.js";
import { Template } from "../../template/Template.js";
import { findVariableValue } from "../../template/findVariableValue.js";

export const BANK_CARD_FEE: Template = {
  id: "16700b22-a2a4-40fb-a012-d7a934dc0848",
  name: "Pangakaardi kuutasu",
  variables: [
    {
      name: "Date",
      type: "date"
    },
    {
      name: "Amount",
      type: "amount_eur"
    }
  ],
  initialValues: [
    {
      name: "Amount",
      value: "2.00"
    }
  ],
  generate: (values) => {
    const date = findVariableValue("Date", values);
    const amount = Math.round(parseFloat(findVariableValue("Amount", values)) * 100);

    const entry: NewEntry = {
      title: "Pangakaardi kuutasu",
      items: [
        {
          title: "Pangakaardi kuutasu võtmine kontolt",
          date: date,
          amount: amount,
          eurAmount: amount,
          currency: "eur",
          debit: Exp_01,
          credit: Ass_03
        }
      ]
    };

    return { type: "success", entry };
  }
};
